import { viewDetailNoc, viewDetailNocHandover, viewDetailNocPickup, viewDetailPartyPeshi, viewDetailPartyPeshiHandover, viewDetailPartyPeshiPickup } from "./tracking";

export const DEFAULT_HOLD = {
    state: "completed",
    subHeading: "At the time of car handover"
};

export const HOLD_STATUS_TYPES = {
    APPROVED: "APPROVED",
    VERIFICATION_FAILED: "VERIFICATION_FAILED",
    REVOKED: "REVOKED",
    PENDING: "PENDING",
    PROCESSED: "PROCESSED"
};

export const HOLD_STATUES = {
    [HOLD_STATUS_TYPES.APPROVED]: "PAYMENT APPROVED",
    [HOLD_STATUS_TYPES.REVOKED]: "MONEY REVOKED",
    [HOLD_STATUS_TYPES.VERIFICATION_FAILED]: "VERIFICATION FAILED",
    [HOLD_STATUS_TYPES.PENDING]: "PENDING",
    [HOLD_STATUS_TYPES.PROCESSED]: "PROCESSED"
};

export const eventScreenTypes = {
    PICKUP: "PICKUP",
    HANDOVER: "HANDOVER",
    OFFER: "OFFER"
};

export const eventScreenTrackingDetails = {
    [eventScreenTypes.PICKUP]: {partyPeshi: viewDetailPartyPeshiPickup, noc: viewDetailNocPickup },
    [eventScreenTypes.HANDOVER]: {partyPeshi: viewDetailPartyPeshiHandover, noc: viewDetailNocHandover },
    [eventScreenTypes.OFFER]: {partyPeshi: viewDetailPartyPeshi, noc: viewDetailNoc}
};
